module.exports = __webpack_public_path__ + "static/img/success_character.55beac3.png";